import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import throttle from 'lodash/throttle';
import Carousel from '../Carousel/Carousel';
import { isDesktopViewport } from '../../helpers/browser';
import FeaturedCard from './FeaturedCard';
import styles from './FeaturedCarousel.less';

class FeaturedCarousel extends Component {
  static propTypes = {
    visible: PropTypes.bool,
    pages: PropTypes.arrayOf(
      PropTypes.shape({
        projectType: PropTypes.string.isRequired,
        targetCurrency: PropTypes.string.isRequired,
        amountRaised: PropTypes.number.isRequired,
        progress: PropTypes.number.isRequired,
        pitch: PropTypes.string.isRequired,
        owner: PropTypes.string.isRequired,
        numberOfSupporters: PropTypes.number.isRequired,
        projectId: PropTypes.string.isRequired,
        projectUrl: PropTypes.string.isRequired,
        projectImage: PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          cropArea: PropTypes.shape({
            top: PropTypes.number,
            left: PropTypes.number,
            width: PropTypes.number,
            height: PropTypes.number,
          }),
        }),
      }).isRequired
    ).isRequired,
    avatars: PropTypes.objectOf(PropTypes.string),
    loadAvatars: PropTypes.func.isRequired,
    selectCard: PropTypes.func.isRequired,
    slideCarousel: PropTypes.func.isRequired,
  };

  static defaultProps = {
    visible: true,
  };

  state = { isDesktop: isDesktopViewport() };

  componentDidMount() {
    if (__CLIENT__) {
      this.resizeHandler = throttle(this.onResize, 60);
      window.addEventListener('resize', this.resizeHandler);
    }
  }

  componentWillUnmount() {
    if (__CLIENT__) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  onResize = () => {
    const { isDesktop } = this.state;

    if (isDesktop !== isDesktopViewport()) {
      this.setState({ isDesktop: !isDesktop });
    }
  };

  render() {
    const {
      visible,
      pages,
      avatars,
      loadAvatars,
      selectCard,
      slideCarousel,
    } = this.props;
    const { isDesktop } = this.state;
    const translationRatio = isDesktop ? -1 : -0.94;

    const transitionStyle = {
      height: visible ? (isDesktop ? 400 : 450) : 0,
      opacity: visible ? 1 : 0,
    };

    return (
      <div styleName="carousel-container" style={transitionStyle}>
        <Carousel
          touchable
          translationRatio={translationRatio}
          styles={styles}
          location="home > show me"
          slideCarousel={slideCarousel}
        >
          {pages.map((page, index) => (
            <FeaturedCard
              key={page.projectId}
              page={page}
              avatars={avatars}
              loadAvatars={loadAvatars}
              selectCard={selectCard}
              rank={index + 1}
              totalCount={pages.length}
            />
          ))}
        </Carousel>
      </div>
    );
  }
}

export default CSSModules(FeaturedCarousel, styles);



// WEBPACK FOOTER //
// ./src/components/Home/FeaturedCarousel.js